import util from '../util'

let controller = 'ParceiroHandshakeHeaders'
export default Object.assign({}, util.GetCrud(controller, null))